import React from "react";
import { Row, Col } from "react-bootstrap";
import { CollectionServerUser, UserIdentifierBase } from "@preveil-api";
import { contentLabels, dayjs, ExportRequest } from "src/common";
import { Icon } from "src/components";
import _ from "lodash";

type AllProps = {
  drop_dir: string;
  export_request: ExportRequest;
  org_users: CollectionServerUser[];
  export_status: string;
  timeframe: string;
}

// Description: Render the receipt of the data export request after completion
function RequestCompletedComponent(props: AllProps) {
  const { export_request, drop_dir, export_status, timeframe, org_users } = props;
  const _requester = org_users.find((u) => u.user_id === export_request.requester);
  const content_label = !!export_request && !!export_request.metadata && 
    [...new Set(
      Object.keys(export_request.metadata)
        .filter((key) => (export_request.metadata as any)[key])
        .map((key) => {
          const _key = key.split("include_")[1];
          return (contentLabels.content as any)[_key];
        })
        .filter((value) => !!value)
    )].join(" & ");

  return <div className="export-container">
    <div className="receipt-header">
      <Icon className="pv-icon-receipt" />
      <div>
        <h5>Data Export Request</h5>
        <p>Receipt</p>
      </div>
    </div>
    <div className="receipt-body">
      <div className="readonly-details small">
        <p><span>Timeframe</span>{timeframe}</p>
        <p><span>Content</span>{content_label}</p>
        <p><span>Output File Path</span>{drop_dir}</p>
        <p><span>Status</span>{_.capitalize(export_status)}</p>
        <p><span>Created</span>{dayjs().format("LLL")}</p>
        {!!_requester && <p><span>Requester</span>{_requester.display_name}</p>}
      </div>
      <div className="approvers-panel">
        <Row className="header-row">
          <Col>Users: {export_request?.metadata?.users.length}</Col>
        </Row>
        <div>
          {export_request?.metadata?.users.map((user: UserIdentifierBase) => {
            const _user = org_users.find((u) => u.user_id === user.user_id);
            return !!_user ?<Row key={user.user_id}>
                <Col xs={10}>
                  {!!_user.display_name && <p className="semi-bold">{_user.display_name}</p>}
                  <p>{user.user_id}</p>
                </Col>
              </Row> : null;
          })}
        </div>
      </div>
    </div>
  </div>;
}

export default React.memo(RequestCompletedComponent);